<template>
  <div class="fullheight">
    <eco-table
        @load="loadData"
        :data="data"
        :pageResult="pageResult"
        :selection="true"
        :show-export="false"
        :show-custom-column="false"
        quick-search-props="transferName,transferedName"
        ref="table">
      <template v-slot:toolbar>
        <el-button-group>
          <el-button size="small" @click="edit()" type="primary">添加</el-button>
          <fe-delete-button
              :url="deleteUrl"
              class="marginLeft16"
              :htTable="$refs.table">删除
          </fe-delete-button>
        </el-button-group>
      </template>
      <template>
        <eco-table-column type="index" width="50" align="center" label="序号" />
        <eco-table-column
            prop="transferName"
            label="移交人"
            :show-overflow-tooltip="true"
            :sortable="true"
            width="150" 
        />
        <eco-table-column
            prop="transferedName"
            label="被移交人"
            :show-overflow-tooltip="true"
            :sortable="true"
            width="150" 
        />
        <eco-table-column
            prop="createTime"
            label="创建时间"
            :show-overflow-tooltip="true"
            :sortable="true"
            width="150" 
        />
        <eco-table-column
            prop="reason"
            label="移交原因"
            :show-overflow-tooltip="true"
            :sortable="true"
        />
        <eco-table-column label="操作" width="210">
          <template slot-scope="scope">
            <el-link @click="detail(scope.row.id)" type="primary" :underline="false">明细</el-link>
          </template>
        </eco-table-column>
      </template>

    </eco-table>
    <transfer-detail :detailData="detailData" ref="transfer"/>
    <transfer-edit @after-save="afterSave" ref="transferEdit"/>
  </div>
</template>

<script>
  import flow from "@/api/flow.js";
  import TransferEdit from "../../components/flow/TransferEdit";
  const transferDetail = () => import("@/components/flow/TransferDetail.vue");
  const transferEdit = () => import("@/components/flow/TransferEdit.vue");
  export default {
    components:{
      transferEdit,
      transferDetail
    },
    data(){
      return{
        data:[],
        pageResult:{
          page:0,
          pageSize:50,
          total:0
        },
        detailData:{},
        deleteUrl:window.context.bpmRunTime+"/runtime/bpmTransRecord/v1/removes"
      }
    },
    methods:{
      loadData(param,cb){
        flow
          .getTransferList(param)
          .then(response => {
            this.data = response.rows;
            this.pageResult = {
              page: response.page,
              pageSize: response.pageSize,
              total: response.total
            }
          })
          .finally(()=>{
            cb()
          })
      },
      edit(){
        this.$refs.transferEdit.handleOpen();
      },
      async detail(id){
        this.detailData = await flow.getTransferById(id);
        this.detailData.url = window.context.bpmRunTime+"/runtime/bpmTransRecord/v1/tran/tranResult?tranId="+this.detailData.id;
        this.$refs.transfer.handleOpen();
      },
      afterSave(){
        this.$refs.table.load();
      }
    }
  }
</script>

<style scoped>

</style>
